// import { configureStore } from '@reduxjs/toolkit';
// import vehicleReducer from './vehicleSlice';
// import routeReducer from './routeSlice';
// import simulationReducer from './simulationSlice';

// export const store = configureStore({
//   reducer: {
//     vehicles: vehicleReducer,
//     routes: routeReducer,
//     simulation: simulationReducer,
//   },
// });

// export default store;

// import { configureStore } from '@reduxjs/toolkit';

// // Placeholder reducers
// const vehicleReducer = (state = { list: [] }, action) => state;
// const routeReducer = (state = { list: [] }, action) => state;
// const simulationReducer = (state = { isRunning: false }, action) => state;

// export const store = configureStore({
//   reducer: {
//     vehicles: vehicleReducer,
//     routes: routeReducer,
//     simulation: simulationReducer,
//   },
// });

// export default store;





// import { configureStore } from '@reduxjs/toolkit';
// import vehicleReducer from './vehicleSlice';
// import routeReducer from './routeSlice';
// 
// export const store = configureStore({
//   reducer: {
//     vehicles: vehicleReducer,
//     routes: routeReducer,
//     simulation: simulationReducer,
//   },
// });

// export default store;

// import { configureStore } from '@reduxjs/toolkit';
// import simulationReducer from './simulationSlice';

// // Placeholder reducers
// const vehicleReducer = (state = { list: [] }, action) => state;
// const routeReducer = (state = { list: [] }, action) => state;

// export const store = configureStore({
//   reducer: {
//     vehicles: vehicleReducer,
//     routes: routeReducer,
//     simulation: simulationReducer,
//   },
// });

// export default store;



import { configureStore } from '@reduxjs/toolkit';
import simulationReducer from './simulationSlice';

// Placeholder reducers
const vehicleReducer = (state = { list: [] }, action) => state;
const routeReducer = (state = { list: [] }, action) => state;

export const store = configureStore({
  reducer: {
    vehicles: vehicleReducer,
    routes: routeReducer,
    simulation: simulationReducer,
  },
});

export default store;